// extracted by mini-css-extract-plugin
export default {"colorFieldTrigger":"svJoe","colorChevron":"CC2gR","colorPickerPopover":"JFogu"};